import client from './api-client';

export const serviceGetCfgForm = async (query) => {
    try {
        const response = await client.get(`cfg-forms?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}

export const serviceGetDeclaracionPago = async (query) => {
    try {
        const response = await client.get(`pago-cuotas?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}
export const serviceGetDocumento = async(query) => {
    try {
        const response = await client.verDocumento(`get-file?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return response.data
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const serviceRendirCuota = async(body) => {
    try {
        const response = await client.post('pago-cuotas/rendir', body);
        return response.data;
    } catch(error) {
        throw error;
    }
}
export const serviceMediosPago = async (query) => {
    try {
        const response = await client.get(`detalles?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}
export const serviceGetHistorialCuota = async (query) => {
    try {
        const response = await client.get(`pago-cuotas?h=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}
export const serviceGetBancos = async (query) => {
    try {
        const response = await client.get(`bancos?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}